import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";

function format(ms: number) {
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
  return `${m}:${String(sec).padStart(2, "0")}`;
}

export function SessionTimer({ startedAt, endedAt, className }: { startedAt: string | null; endedAt?: string | null; className?: string }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (endedAt || !startedAt) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [startedAt, endedAt]);

  if (!startedAt) {
    return <span className={cn("text-xs text-muted-foreground inline-flex items-center gap-1", className)}><Clock className="w-3 h-3" /> --:--</span>;
  }
  const start = new Date(startedAt).getTime();
  const end = endedAt ? new Date(endedAt).getTime() : now;
  return (
    <span className={cn("text-xs text-muted-foreground inline-flex items-center gap-1 tabular-nums", className)}>
      <Clock className="w-3 h-3" /> {format(end - start)}
    </span>
  );
}
